<template>
  <div class="stepContent">
    <div class="uploadTip">
      <div class="uploadTip-title">
        导入结果
      </div>
      <div class="uploadTip-lists">
       <!-- <div v-if="success" class="uploadTip-list">
          导入成功 <span class="uploadFail">{{ errorCount }}</span> 条
        </div>-->
        <div class="uploadTip-list">
          导入成功 <span class="uploadFail">{{ successCount }}</span> 条
        </div>
        <div class="uploadTip-list">
          导入失败 <span class="uploadFail">{{ errorCount }}</span> 条
          <div v-if="errorCount>0" style="max-height: 200px;overflow-y: auto">
            <p v-for="(item) in errMsgList">{{item}}</p>
          </div>
<!--        &lt;!&ndash;  <span v-if="errorCount>0">-->
<!--            , 下载<span class="uploadTip-button" @click="exportErrData">《错误数据信息表》</span>-->
<!--          </span>&ndash;&gt;-->
        </div>
      </div>
    </div>
    <div class="next">
      <el-button type="primary" @click="over">完成</el-button>
    </div>
  <!--  <el-button class="import" type="primary" @click="next">下一步</el-button>
    <el-button class="import" type="primary" @click="rematch">重新匹配</el-button>-->
  </div>
</template>
<script>
import {downloadErrorExcle} from "@/api/demo/demo"
import { downloadFile } from '@/util/util';
import {mapGetters} from "vuex";
export default {
  computed: {
    ...mapGetters([ "loginInfo"])
  },
  data() {
    return {
      successCount: 0,
      error: false,
      success: true,
      errorCount: 0,
      errMsgList: [],
      data:{
        tableNames: '',
        fileName: '',
        tmplIds: '',
      }
    }
  },
  mounted() {
    this.successCount = this.$store.state.impData.successCount
    this.errorCount = this.$store.state.impData.errorCount
    this.success = this.$store.state.impData.success
    this.errMsgList = this.$store.state.impData.errMsgList
    if (this.success) {
      this.error = false
    } else {
      this.error = true
    }
  },
  methods: {
    next() {
      this.$emit('next') // 跳转下一步
    },
    rematch() {
      this.$emit('rematch') // 跳转上一步
    },
    over() {
      if(this.loginInfo.userType==1){
        this.$router.push({
          path: '/cus/emp'
        })
      }else{
        this.$router.push({
          path: '/emp/manage'
        })
      }
    },
    //  下载上传的错误信息
    exportErrData() {
      downloadErrorExcle(this.data).then(res=>{
        downloadFile(res)
      })
    }
  }
}
</script>
<style scoped  rel="stylesheet/scss">

  .uploadContent .iconfont{
    font-size: 80px;
    color:#cccccc;
  }
  .uploadTip-lists{
    padding-left:20px;
  }
  .uploadTip-list .uploadTip-button{
    color:#269cff;
    text-decoration: underline;
    cursor: pointer;
  }
  .uploadSuccess{
    font-weight: bold;
    font-size: 16px;
    color: #3c763d;
  }
  .uploadFail{
    font-weight: bold;
    font-size: 16px;
    color: red;
  }
  .next{
    position: absolute;
    bottom: 20px;
    text-align: center;
    width: 100%;
  }
</style>
